<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close">
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">manage tags</h4>
</div>

<div class="modal-body">
  <div class="loading" *ngIf="loading" style="border-radius: 16px;">
    <div class="loader">Loading...</div>
  </div>
  Jobs selected: {{ jobs.length }}
  <div>
    <p>Available tags</p>
    <ch-tag *ngFor="let tag of tags"
      [name]="tag.name"
      [color]="tag.color"
      [canRemove]="false"
      (click)="addToSelection(tag)"
      >
    </ch-tag>
  </div>

  <div  *ngIf="action === 'add'">
    <p>Choose the tags that will be added to selected jobs</p>
  </div>

  <div *ngIf="action === 'remove'">
    <p>Choose the tags that will be removed from the selected jobs</p>
  </div>

  <div>
    <ch-tag *ngFor="let tag of selectedTags"
      [name]="tag.name"
      [color]="tag.color"
      [canRemove]="true"
      (click)="removeFromSelection(tag)"
      >
    </ch-tag>
  </div>
</div>

<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    Cancel
  </div>
  <div class="btn btn-primary pull-right" aria-label="Confirm" (click)="confirm()">
    {{ action }} tags
  </div>
</div>